// let head_url = 'http://localhost:3000/v2'
// head_url = 'https://release.internal.hzinsights.com'
// head_url = 'http://10.9.58.3:8608'
export const setting_staticfile_url = 'https://release.internal.hzinsights.com';
export const setting_firstformula_name = '弘则数据';
export const setting_luckysheetdata_cnfinancialinfo_url = 'https://luckysheetdata.internal.hzinsights.com/cn/financialinfo';
export const setting_luckysheetdata_stockdata_url = 'https://luckysheetdata.internal.hzinsights.com/cn/stock4data';
export const setting_luckysheetdata_tablename_url = 'https://luckysheetdata.internal.hzinsights.com/luckysheet/tablename';
export const setting_luckysheetdata_write_url = 'https://luckysheetdata.internal.hzinsights.com/luckysheet/write';